import { createSearchIntegration } from './search';
import { createFilterIntegration } from './filter';
import { createItinerarySelectionIntegration } from './itinerarySelection';
export const createFlightResultsIntegration = (storageClient, of1Props, fetch) => ({
  filter: createFilterIntegration({
    fetch
  }),
  itinerarySelection: createItinerarySelectionIntegration(of1Props),
  search: createSearchIntegration(storageClient, of1Props)
});